import { render, staticRenderFns } from "./XInputGroupCurrency.vue?vue&type=template&id=293a4592&"
import script from "./XInputGroupCurrency.vue?vue&type=script&lang=js&"
export * from "./XInputGroupCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports